import SafariPrintUtil from './safari-screen-print-discovery-util';
import FeatureUtils from 'utils/features';
import Reactor from '../data/reactor';
import CommonValues from '../resources/common-values';
import Analytics from '../utils/analytics';
import RuntimeGetters from '../data/app-runtime/getters';

let printMediaQueryList = null;
let unsubscribe = null;
const setUpEventListeners = (beforePrint, afterPrint) => {
    if (FeatureUtils.isSafari()) {
        unsubscribe = SafariPrintUtil.before(window, () => {
            beforePrint();
        });
        SafariPrintUtil.after(window, () => {
            afterPrint();
        });
    } else {
        window.addEventListener('beforeprint', beforePrint); // For IE and Firefox
        window.addEventListener('afterprint', afterPrint);
    }
};

const getPrintMediaQueryList = () => {
    if (window.matchMedia && !printMediaQueryList) {
        printMediaQueryList = window.matchMedia('print');
    }
    return printMediaQueryList;
};

const updateMQLPrintEventListener = (listener, shouldAdd = true) => {
    const mql = getPrintMediaQueryList();
    if (mql) {
        shouldAdd ? mql.addListener(listener) : mql.removeListener(listener);
    }
};

/*
 *  Meant to be used in conjunction with the unsubscribe callback from 'safar-screen-print-discovery-util'
 */
const tearDownEventListeners = (beforePrint, afterPrint) => {
    if (FeatureUtils.isSafari()) {
        if (unsubscribe) {
            unsubscribe(); // unsubs from webkit event listeners }
        }
    } else {
        updateMQLPrintEventListener(beforePrint, false);
        window.removeEventListener('afterprint', afterPrint);
        window.removeEventListener('beforeprint', beforePrint); // For IE and Firefox
    }
};

export function capturePrintEvent(event) {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    const selectedModule = Reactor.evaluate(RuntimeGetters.expandedModule)
        ? Reactor.evaluate(RuntimeGetters.expandedModule)
        : 'default';

    if (event.ctrlKey && charCode === 'p') {
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, selectedModule);
    }

    // In MAC metaKey detects cmd key
    else if (event.metaKey && charCode === 'p') {
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, selectedModule);
    }
}

export default {
    setUpEventListeners,
    tearDownEventListeners,
    capturePrintEvent,
};
